<template>
  <AppHeaderDropdown class="mr-2 server-dropdown" right>
    <template slot="header">
       <vue-image :src="current_guild.icon" className="img-avatar"/>
     </template>

    <template slot="dropdown">
      <div v-if="current_guild" class="server-dropdown__current">
        <vue-image :src="current_guild.icon" className="img-avatar" height="25" styles="padding: 0" width="25"/>
        <div class="server-dropdown__current-meta">
          <div class="server-dropdown__current-label">Current server</div>
          <strong class="server-dropdown__name">{{ current_guild.name }}</strong>
        </div>
      </div>
      <div class="scrollable-items">
        <b-dropdown-item
          v-for="g in acceptable_guilds"
          :key="g.id"
          :to="'/dashboard/' + g.id + '/botsettings'"
          class="server-dropdown__item"
        >
          <vue-image :src="g.icon" className="img-avatar" height="25" styles="padding: 0" width="25"/>
          <strong class="ml-3 server-dropdown__name">{{ g.name }}</strong>
        </b-dropdown-item>
      </div>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from "@coreui/vue";
import VueImage from "@/components/VueImage";
export default {
  name: "DefaultHeaderDropdownServer",
  components: {
    AppHeaderDropdown,
    VueImage,
  },
  data: () => {
    return {};
  },
  methods: {
    logout() {
      this.$store.commit("logout");
      this.axios.get("/api/logout").then(this.$router.push("/"));
    }
  },
  computed: {
    current_user() {
      return this.$store.state.discord_user || {};
    },
    avatar_url() {
      return `https://cdn.discordapp.com/avatars/${this.current_user.id}/${this.current_user.avatar}.png?size=64`;
    },
    current_guild() {
      return this.$store.state.discord_guilds.find(
        x => x.id == this.$route.params.guild_id
      );
    },
    acceptable_guilds() {
      return this.$store.state.discord_guilds.filter(
        x => !x.link && x.id != this.current_guild.id
      );
    }
  }
};
</script>
<style>
.server-dropdown .dropdown-menu {
  min-width: 260px;
  max-width: 320px;
  padding-top: 0;
}
.server-dropdown__current {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: rgba(158, 128, 255, 0.12);
  border-left: 3px solid #9e80ff;
  cursor: default;
}
.server-dropdown__current-meta {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1 1 auto;
}
.server-dropdown__current-label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #9e80ff;
  margin-bottom: 1px;
}
.server-dropdown__current .server-dropdown__name {
  color: #fff;
}
.server-dropdown .scrollable-items {
  max-height: 50vh;
  overflow-y: auto;
  overflow-x: hidden;
}
.server-dropdown__item .dropdown-item {
  display: flex;
  align-items: center;
  min-width: 0;
}
.server-dropdown__name {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.server-dropdown .scrollable-items::-webkit-scrollbar {
  width: 7px;
}
.server-dropdown .scrollable-items::-webkit-scrollbar-track {
  background: transparent;
}
.server-dropdown .scrollable-items::-webkit-scrollbar-thumb {
  background: #2d2433;
  border-radius: 5px;
}
</style>
